import { makeStyles } from "@material-ui/styles";
import theme from "src/theme";
import { Modal as MaterialModal, Backdrop, Fade } from "@material-ui/core";

const useStyles = makeStyles({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // background: "rgba(0, 0, 0, 0.4)",
  },
  paper: {
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 10,
    backgroundColor: "#FFFFFF",
  },
});

const Modal = (props) => {
  const classes = useStyles();
  return (
    <MaterialModal
      className={classes.modal}
      open={props.open}
      closeAfterTransition
      hideBackdrop
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open}>
        <div
          className={classes.paper}
          style={{
            ...props.style,
            width: props.width || "auto",
            height: props.height || "auto",
          }}
        >
          {props.children}
        </div>
      </Fade>
    </MaterialModal>
  );
};

export default Modal;
